<div class="alumni-page">
  <app-header-style-seven></app-header-style-seven>

  <div class="custom-container">
    <section class="alumni-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Institution Document</span>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>

        <div class="hero-stats">
          <div class="stat-card" *ngFor="let stat of heroStats">
            <span class="stat-label">{{ stat.label }}</span>
            <strong>{{ stat.value }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="alumni-shell">
      <aside class="alumni-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">NIRF Menu</span>
          <h2>FMCET NIRF</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="alumni-main">
        <section class="content-head-card">
          <span class="content-tag">NIRF Document</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Fatima Michael College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="section-head">
                <h3>NIRF</h3>
                <p>
                  National Institutional Ranking Framework document for institutional reference.
                </p>
              </div>

              <div class="pdf-viewer-container">
                <app-example-pdf-viewer></app-example-pdf-viewer>
              </div>
            </section>
          </ng-container>
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Institution Record</span>
        <h3>NIRF Document Access</h3>
        <p>
          Access the NIRF-related institutional document in a clean embedded view.
        </p>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Reference</span>
        <h3>Institutional Documentation</h3>
        <p>
          This section provides direct access to the NIRF document for viewing and reference.
        </p>
      </article>
    </section>
  </div>
</div>